"use client"

import { createContext, useState, useContext, Dispatch, SetStateAction, ReactNode } from "react";

export type RefineFunctions = {
  brand: ((value: string) => void) | null;
  allergens: (() => void) | null
  flyer: ((value: string) => void) | null;
};

type RefineContextType = {
  refineFunctions: RefineFunctions;
  setRefineFunctions: Dispatch<SetStateAction<RefineFunctions>>;
};

const defaultContextValue: RefineContextType = {
  refineFunctions: { brand: null, allergens: null, flyer: null },
  setRefineFunctions: () => {},
};

const RefineContext = createContext<RefineContextType>(defaultContextValue);

export const RefineContextProvider = ({ children }: { children: ReactNode }) => {
  const [refineFunctions, setRefineFunctions] = useState<RefineFunctions>(defaultContextValue.refineFunctions);

  return (
    <RefineContext.Provider value={{ refineFunctions, setRefineFunctions }}>
      {children}
    </RefineContext.Provider>
  );
};

export const useRefine = () => useContext(RefineContext);


